export const ACTIONS = {
   SET: 'SET',
   CLOSE_DIALOG: 'CLOSE_DIALOG',
   OPEN_DIALOG: 'OPEN_DIALOG',
   PUSH: 'PUSH',
   POP: 'POP',
   REFRESH_DATA: 'REFRESH_DATA',
   LOCAL_CREATE: 'LOCAL_CREATE',
   LOCAL_UPDATE: 'LOCAL_UPDATE',
   LOCAL_REMOVE: 'LOCAL_REMOVE',
}
